import moment from "moment-msdate";

import IFormulaBase from "./formulaBase";
import { makeDisplayMvtsLink, setApiURL } from "@taskpane/utils";
import { standardDateFormat } from "@taskpane/types";
import { Endpoints } from "../core/endpoints";


export interface GLBalanceFormulaData {
  companyName: string;
  fiscalYear: string;
  account: string;
  currency: string;
  fromDate: string;
  toDate: string;
  withProvisionalEntries: string;
  originalCurrency: string;
  debits: string;
  credits: string;
}

export class GLBalanceFormula implements IFormulaBase {

  constructor(private token: string | null = null) { }

  private name = "PMGLBalance";
  formulaData: GLBalanceFormulaData;

  generate(): string {
    const data = this.formulaData;
    return `#${this.name}/${data.companyName}/${data.fiscalYear}/${data.account}/${data.currency}/{${data.fromDate}}/{${data.toDate}}/${data.withProvisionalEntries}/${data.originalCurrency}/${data.debits}/${data.credits}`;
  }

  async getAmount(): Promise<number | string> {
    const data = this.formulaData;
    return await fetch(setApiURL(Endpoints.getTrialBalance(data.companyName, data.fiscalYear)) + "?" + new URLSearchParams({
      from_date: data.fromDate,
      to_date: data.toDate,
      from_account: data.account,
      to_account: data.account,
      currency_code: data.currency,
      //with_zero_accounts: true ? "true" : "false",
      with_movements: true ? "true" : "false",
      with_initial_balance: true ? "true" : "false",
      with_original_currency: data.originalCurrency ? "true" : "false",
      with_provisional_entries: data.withProvisionalEntries ? "true" : "false",
      debits: data.debits ? "true" : "false",
      credits: data.credits ? "true" : "false",
    }).toString(), { method: 'GET', headers: { 'X-Apikey': this.token } }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      };
      return response.json();
    });
  }

  parse(value: string): IFormulaBase {
    if (!isNaN(<any>value)) return null;
    if (!value) return null;
    if (!value.startsWith("#" + this.name)) return null;
    const formulaInst = new GLBalanceFormula(this.token);

    let tvalue = value;
    let match = tvalue.match(/\{[0-9,/-]*\}/);

    while (match && match.length > 0) {
      const concatValue = match[0]
        .substring(1, match[0].length - 1);

      tvalue =
        tvalue.substring(0, tvalue.indexOf(match[0])) +
        (!isNaN(<any>concatValue) ? concatValue :
          concatValue.replace(/\//g, "dateSep")
            .replace(",", ".")) +
        tvalue.substring(tvalue.indexOf(match[0]) + match[0].length);
      match = tvalue.match(/\{[0-9,/-]*\}/);
    }

    const values = tvalue.split("/");
    const fromDateString = !isNaN(<any>values[5]) ? values[5] : values[5].replace(/dateSep/g, "/");
    const toDateString = !isNaN(<any>values[6]) ? values[6] : values[6].replace(/dateSep/g, "/");

    formulaInst.formulaData = {
      companyName: values[1],
      fiscalYear: values[2],
      account: values[3],
      currency: values[4],
      fromDate: !isNaN(<any>fromDateString) ? moment.fromOADate(fromDateString).format(standardDateFormat) : fromDateString,
      toDate: !isNaN(<any>toDateString) ? moment.fromOADate(toDateString).format(standardDateFormat) : toDateString,
      withProvisionalEntries: values[7].toLowerCase(),
      originalCurrency: values[8].toLowerCase(),
      debits: values.length > 9 ? values[9].toLowerCase() : "true",
      credits: values.length > 10 ? values[10].toLowerCase() : "true",
    };
    return formulaInst;
  }

  getDisplayMvtsLink(): string {
    return makeDisplayMvtsLink(this.formulaData.companyName,
      this.formulaData.fromDate,
      this.formulaData.toDate,
      this.formulaData.account,
      this.formulaData.account,
      this.formulaData.currency,
      true,
      true,
      true,
      this.formulaData.withProvisionalEntries === 'true',
      this.formulaData.debits === 'true',
      this.formulaData.credits === 'true');
  }

  async getMvts() {
    const data = this.formulaData;
    const result = await fetch(setApiURL(Endpoints.getTrialBalanceMvts(data.companyName, data.fiscalYear)) + "?" + new URLSearchParams({
      from_date: data.fromDate,
      to_date: data.toDate,
      from_account: data.account,
      to_account: data.account,
      currency_code: data.currency,
      //with_zero_accounts: withZeroAccounts ? "true" : "false",
      with_movements: true ? "true" : "false",
      with_initial_balance: true ? "true" : "false",
      with_provisional_entries: data.withProvisionalEntries ? "true" : "false",
      debits: data.debits ? "true" : "false",
      credits: data.credits ? "true" : "false",
    }).toString(), { method: 'GET', headers: { 'X-Apikey': this.token } }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      };
      return response.json();
    });
    return result;
  }
}
